export const colorsDeclarations: any = {
  green:{
    primary: '#179269',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
  purple: {
    primary: '#7f00bf',
    secondary: '#FDF1BA',
  },
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
};

// ---> Duplicata pour export : /common/exports/eBoarding/events.js
export const colorsHistory: {[id:string]:{primary:string, secondary?:string, icon?:string, explain?:string, bgClass?:string, textClass?:string}} = {
  add:{
    primary: '#179269',
    secondary: '#FAE3E3',
    icon: 'fa fa-light fa-square-plus',
    explain: 'Ajout',
    bgClass: 'bg-green-100',
    textClass: 'text-green-500'
  },
  edit:{
    primary: '#e3bc08',
    secondary: '#FDF1BA',
    icon: 'fa fa-light fa-floppy-disk',
    explain: 'Edition',
    bgClass: 'bg-yellow-100',
    textClass: 'text-yellow-500'
  },
  login: {
    primary: '#00ba9d',
    secondary: '#D1E8FF',
    icon: 'fa fa-light fa-user-unlock',
    explain: 'Connexion',
    bgClass: 'bg-green-100',
    textClass: 'text-green-500'
  },
  suivi: {
    primary: '#7f00bf',
    secondary: '#FDF1BA',
    icon: 'fa fa-light fa-envelope',
    explain: 'Suivi',
    bgClass: 'bg-purple-100',
    textClass: 'text-purple-500'
  },
  valideCheckIn: {
    primary: '#3600bf',
    secondary: '#ffffff',
    icon: 'fa fa-light fa-shield-check',
    explain: 'Confirmation rappel checkin sinistre',
    bgClass: 'bg-blue-100',
    textClass: 'text-blue-500'
  },
  statut: {
    primary: '#1d8600',
    secondary: '#FDF1BA',
    icon: 'fa fa-light fa-gear',
    explain: 'Changement statut',
    bgClass: 'bg-green-100',
    textClass: 'text-green-500'
  },
  intervention: {
    primary: '#ff8322',
    secondary: '#FDF1BA',
    icon: 'fa fa-light fa-location-plus',
    explain: 'Intervention',
    bgClass: 'bg-orange-100',
    textClass: 'text-orange-500'
  },
  export:{
    primary: '#3b9eff',
    secondary: '#D1E8FF',
    icon:'fa fa-light fa-file-export',
    explain: 'Export PDF',
    bgClass: 'bg-blue-100',
    textClass: 'text-blue-500'
  },
  download:{
    primary: '#0072d9',
    secondary: '#D1E8FF',
    icon:'fa fa-light fa-download',
    explain: 'Télechargement',
    bgClass: 'bg-blue-100',
    textClass: 'text-blue-500'
  },
  delete: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
    icon:'fa fa-light fa-trash',
    explain: 'Suppression',
    bgClass: 'bg-red-100',
    textClass: 'text-red-500'
  },

  changeStatut:{
    primary: '#a29200',
    secondary: '#FAE3E3',
    icon:'fa fa-light fa-bolt',
    explain: 'Changement de statut',
    bgClass: 'bg-yellow-100',
    textClass: 'text-yellow-500'
  }
};

// ---> Duplicata pour export : /common/exports/eBoarding/events.js
export const ObjectsToName:any = {
  IntraDoSinistre: 'Sinistre',
  People: 'Utilisateur',
  IntraComment: 'Commentaire réclamation',
  Operation: 'Opération corporate',
  IntraDoReclamation: 'Réclamation',
  IntraDoOperation: 'Opération DOnet',
  IntraOperation: 'Opération GPAnet',
  Societes: 'Société',
  IntraDocument: 'Document opération GPAnet',
  IntraFiles: 'Fichier réclamation',
  IntraPhotos: 'Photo réclamation',
  IntraOpComment: 'Commentaire opération GPAnet',
  IntraDoCommentSinistre: 'Commentaire sinistre DOnet',
  IntraDoDevis: 'Devis sinistre',
  IntraDoDocument: 'Document opération DOnet',
  IntraOperationDocument: 'Document opération',
  IntraDoIndemnite: 'Indemnité',
  IntraDoExtension: 'Extension sinistre',
  IntraDoFiles: 'Fichier sinistre',
  IntraDoHistorique: 'Suivi de sinistre',
  IntraEbChat: 'Chat',
  IntraEbHistory: 'Événement historique'
}
